import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';

const toolName = 'list-target-languages' as const;

const argumentZod = z.object({});

export const listTargetLanguagesManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'List target languages',
  prettyStatus: {
    executing: 'Listing target languages…',
    executed: 'Listed target languages',
    failed: 'Listing target languages failed',
  },
  family: 'localization',
  llmTool: {
    name: toolName,
    description:
      'Lists the locales for the current site, including the primary (source) locale and every target language. Each row includes the tag needed to scope a translation exclusion rule by language -- only non-primary locales are valid translation targets. A locale with isManagedByContinuousTranslation=true is kept in sync by continuous translation: it is read-only and rejects writes of localized content (409 locale_managed_by_continuous_translation). ALWAYS call this tool before editing localized content or declining to, and to answer which locales are managed by continuous translation or read-only. Do not guess. For a managed locale, do not write; tell the user to edit the primary locale or turn off Auto-sync for that language.',
    inputSchema: argumentZod,
  },
  type: 'server',
  requiredScopes: ['sites:read'],
  permission: [{resource: 'Site', action: 'read'}],
  confirmBeforeExecuting: false,
  isReadOnly: () => true,
});

export type ListTargetLanguagesArgumentType = z.infer<typeof argumentZod>;
